export type PaymentStatus = PaymentStatusEnum;

export enum PaymentStatusEnum {
  'UNREGISTERED_TIMED_OUT' = 'UNREGISTERED_TIMED_OUT',
  'UNREGISTERED' = 'UNREGISTERED',
  'PENDING' = 'PENDING',
  'APPROVED' = 'APPROVED',
  'DECLINED' = 'DECLINED'
}
